<div [class.dense]="dense" [matTooltip]="tooltip" [matTooltipPosition]="tooltipPosition" [matTooltipDisabled]="!hasTooltip">
  <button
    [class]="color"
    mat-icon-button
    type="button"
    [routerLink]="buttonLink"
    (click)="action.emit($event)"
    [disabled]="disabled"
    [tabIndex]="noFocus ? -1 : undefined"
  >
    <mat-icon [class.material-icons-outlined]="outlined">{{ icon }}</mat-icon>
  </button>
</div>
